import React from 'react';
import { Reveal } from '../ui/Reveal';
import { VentureCard } from '../ui/VentureCard';
import { ventures } from '../../data/ventures';
import type { Interest } from '../../types/contact';
type VenturesSectionProps = {
  onRequestContact: (interest: Interest) => void;
};
export function VenturesSection({
  onRequestContact
}: VenturesSectionProps) {
  return <section id="what-i-do" aria-labelledby="ventures-heading" className="bg-brand-mist" data-id="element-178" data-mp="3gxseqqqigm0l">
      <div className="px-fluid py-section" data-id="element-179" data-mp="hidto42uy60r">
        <div className="grid items-end gap-6 lg:grid-cols-12 lg:gap-fluid" data-id="element-180" data-mp="cl5b42dsrzyz">
          <Reveal className="lg:col-span-5" data-id="element-181" data-mp="8jjr7x2uilfa">
            <h2 id="ventures-heading" className="text-h2 font-extrabold text-brand-navy" data-id="element-182" data-mp="8igzjmxp8eyb">
              What I’m Building
            </h2>
          </Reveal>
          <Reveal delay={0.05} className="lg:col-span-7" data-id="element-183" data-mp="2t9rc1yg0jzt3">
            <p className="text-lead max-w-[48ch]" data-id="element-184" data-mp="2tbc6zp68pkrh">
              Everything I do now comes back to one idea: make business simpler so owners can focus on growth.
            </p>
          </Reveal>
        </div>

        <ul className="mt-[clamp(2.5rem,4.5vw,6rem)] grid gap-[clamp(1.25rem,2vw,3rem)] md:grid-cols-3" data-id="element-185" data-mp="qfgv74qyr12o">
          {ventures.map((venture, i) => <Reveal as="li" key={venture.name} delay={i * 0.05} className="h-full" data-id="element-186" data-mp="hhofw0l8rtfa" data-mpi={i}>
              <VentureCard venture={venture} data-id="element-187" data-mp="mfgj3qrc71ys" />
            </Reveal>)}
        </ul>

        <p className="text-body-fluid mt-[clamp(2rem,3vw,3.5rem)]" data-id="element-188" data-mp="7rbygh8q4gdd">
          Interested in partnering or using any of these?{' '}
          <a href="#contact" onClick={e => {
          e.preventDefault();
          onRequestContact('Partnering');
        }} className="font-bold text-brand-blue underline decoration-2 underline-offset-4 hover:text-brand-navy" data-id="element-189" data-mp="citx2yn9y4v6">
            Let’s talk.
          </a>
        </p>
      </div>
    </section>;
}